'use client';

import Modal from './base';
import { confirm } from './confirm';

export type { IModalRef, IModalProps } from './base';
export type { IModalConfirmOptions } from './confirm';
export { confirm };

type TModal = typeof Modal & {
    confirm: typeof confirm;
};

const ModalWithConfirm = Modal as TModal;
ModalWithConfirm.confirm = confirm;

export default ModalWithConfirm;
